module.exports = __webpack_public_path__ + "static/media/solution-tube-a-full-closed.87fc28fa.svg";